<template lang="pug">
form(@submit.prevent='onConfirm')
  modal.active(
    :active='showModal'
    @close='$router.back()',
    :title='`Comentar no Documento (${current.numero}/${current.ano})`'
  )
    div(slot='modal-body')
      div Esse comentário será adicionado ao Documento.
      .divider
      .columns
        .column.col-auto
          form-group(:label="'comentario.realizado_em' | tModel" :validation="$v.comentario.realizado_em")
            div(v-if="$v.comentario.realizado_em.$model === 'now'")
              .has-icon-right.c-hand(@click="$v.comentario.realizado_em.$model = ''")
                .form-input Agora
                i.form-icon.fa.fa-calendar.text-primary.tooltip(data-tooltip='Alterar')
            .columns(v-else)
              .column
                datepicker(
                  v-model="$v.comentario.realizado_em.$model"
                  type="datetime"
                  format="DD/MM/YYYY HH:mm"
                )
              .column.col-auto
                a.btn.btn-link.mt-1(
                  @click="$v.comentario.realizado_em.$model = 'now'"
                )
                  i.fa.fa-calendar
                  |  Agora
        .column
      form-group(:label="'comentario.comentario_situacao' | tModel" :validation="$v.comentario.comentario_situacao_id")
        comentario-situacao-picker(v-model.trim="$v.comentario.comentario_situacao_id.$model" rows="5")
      div
        form-group(:label="'comentario.descricao' | tModel" :validation="$v.comentario.descricao")
          textarea.form-input(v-model.trim="$v.comentario.descricao.$model" rows="5")
      div(v-if="comentario.anexos.length > 0")
        a.c-hand(@click="$refs.modalAnexos.open()")
          | {{ countFotos }} {{ countFotos === 1 ? 'imagem adicionada ao comentário' : 'imagens adicionadas ao comentário' }}
      anexos(v-model="$v.comentario.anexos.$model")
      modal-anexos(ref="modalAnexos" :anexos="comentario.anexos" @remove="onRemoveAnexo" @unremove="onUnremoveAnexo")
      .divider
    div(slot='modal-footer')
      button.btn.btn-primary(
        :disabled='$v.$invalid || loading || uploading',
        :class='{ loading }'
      )
        btn-content(name='confirm' label="Comentar")
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators'
import toastErrors from '@/lib/errors/toastErrors'
import Comentario from '@/models/Comentario'
import Anexos from './form/components/Anexos'
import ModalAnexos from './form/components/ModalAnexos'

export default {
  vuex: {
    uploads: {
      state: ['uploading'],
    },
    'fiscalizacao/docs': {
      state: ['current'],
      actions: ['fetchComentar'],
    },
  },
  components: { Anexos, ModalAnexos },
  data() {
    return {
      comentario: new Comentario(),
      loading: false,
      showModal: true,
    }
  },
  methods: {
    async onConfirm() {
      try {
        this.loading = true
        const { id } = this.current
        const params = { id, comentario: this.comentario }
        await this.fetchComentar(params)
        this.$toaster.success('Comentado com sucesso')
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      } finally {
        this.loading = false
      }
    },
    onRemoveAnexo(index) {
      if (this.comentario.anexos[index].id) {
        this.comentario.anexos[index]._destroy = true
      } else {
        this.$delete(this.comentario.anexos, index)
      }
    },
    onUnremoveAnexo(index) {
      this.comentario.anexos[index]._destroy = false
    },
  },
  computed: {
    countFotos() {
      return this.comentario.anexos.filter(({ _destroy }) => !_destroy).length
    },
  },
  validations: {
    comentario: {
      descricao: {
        required,
        minLength: minLength(10),
      },
      realizado_em: {},
      anexos: { $each: {} },
      comentario_situacao_id: {},
    },
  },
}
</script>
